import { observable, computed } from 'mobx'

const emptyIterator = function*(){}

const delegate = (proto, name) => ({
  type: 'method',
  enumerable: false,
  configurable: false,
  writable: false,
  initializer() { return function (...args) {
    return (this.records || [])[name](...args)
  }}
})

export default class Store {
  @observable records

  @computed get loaded() {
    return this.records !== undefined
  }

  @delegate map
  @delegate forEach
  @delegate filter
  @delegate reduce
  @delegate find
  @delegate findIndex

  constructor(connection) {
    this.connection = connection
    this[Symbol.iterator] = () => {
      return this.records ? this.records[Symbol.iterator]() : emptyIterator()
    }

    this.load = this.load.bind(this)
    this.create = this.create.bind(this)
    this.update = this.update.bind(this)
    this.delete = this.delete.bind(this)
  }

  findById = id => this.find(item => item.id === Number(id))
  findIndexById = id => this.findIndex(item => item.id === Number(id))

  load(id) {
    return this.connection.load(id)
      .then(resp => resp.data)
      .then(data => {
        if (id) {
          if (this.findById(id)) {
            // NOTE this updates properties on the current record with new data
            // but this will not remove properties that may no longer exist.
            // If this becomes an issue we can compare properties and delete
            // any superfalous properties. But we have to update the existing
            // record. If we just re-assign it, or even remove and re-add it.
            // Any observers of the previous record will not be notified of the
            // new record because it will be a new object, (not the one being
            // observed).
            const record = this.records[this.findIndexById(data.id)]
            Object.assign(record, data)
          } else {
            this.records = [ ...(this.records || []), data ]
          }
        } else {
          this.records = data
        }
      })
  }

  create(data) {
    return this.connection.create(data)
      .then(resp => resp.data)
      .then(data => {
        this.records = [ ...(this.records || []), data ]
        return data
      })
  }

  update(data) {
    return this.connection.update(data)
      .then(() => {
        this.records[this.findIndexById(data.id)] = data
        return data
      })
  }

  delete(id) {
    return this.connection.delete(id)
      .then(() => this.records.remove(this.findById(id)))
  }

}



// WEBPACK FOOTER //
// client/stores/store.js